<div class="command-palette" role="dialog" aria-label="Azioni rapide">

  @switch (step) {

    @case ('search') {
      <div class="palette-search">
        <ion-item lines="none" class="search-item">
          <ion-icon name="search-outline" slot="start" aria-hidden="true"></ion-icon>
          <ion-input
            type="text"
            placeholder="Cerca un'azione o scrivi una frase..."
            [value]="searchText"
            (ionInput)="onSearchChange($any($event).detail.value ?? '')"
            autofocus="true"
            aria-label="Cerca un'azione o scrivi una frase"
            aria-controls="palette-results"
            aria-activedescendant="palette-item-{{activeIndex}}"
            role="combobox"
            aria-expanded="true"
            aria-autocomplete="list">
          </ion-input>
          @if (searchText) {
            <ion-button
              slot="end"
              fill="clear"
              color="primary"
              (click)="handleEnter()"
              aria-label="Invia frase">
              <ion-icon name="send-outline" slot="icon-only"></ion-icon>
            </ion-button>
          }
        </ion-item>

        <!-- Example chips (empty state) -->
        @if (!searchText) {
          <div class="example-chips" aria-label="Esempi di comandi">
            <span class="example-chips-label">Prova con:</span>
            <div class="example-chips-list">
              @for (example of EXAMPLE_CHIPS; track example.text) {
                <ion-chip
                  color="primary"
                  (click)="applyExample(example.text)"
                  [attr.aria-label]="'Esempio: ' + example.text">
                  <ion-icon [name]="example.icon" aria-hidden="true"></ion-icon>
                  <ion-label>{{ example.text }}</ion-label>
                </ion-chip>
              }
            </div>
          </div>
        }

        <!-- NLU loading indicator -->
        @if (nluLoading && (!parseResult || parseResult.confidence === 'none')) {
          <div class="nlu-loading" role="status" aria-label="Analisi in corso">
            <ion-spinner name="dots" color="primary"></ion-spinner>
            <span>Analizzo la frase…</span>
          </div>
        }

        <!-- Token pill preview -->
        @if (parseResult && parseResult.confidence !== 'none') {
          <div class="parse-preview" aria-live="polite" [attr.aria-label]="previewAnnouncement">
            @for (token of parseResult.tokens; track token.raw) {
              @if (token.type !== 'noise') {
                <ion-chip
                  [color]="getTokenColor(token)"
                  class="preview-chip"
                  [attr.aria-label]="getTokenAriaLabel(token)">
                  <ion-icon [name]="getTokenIcon(token)" aria-hidden="true"></ion-icon>
                  <ion-label>{{ token.resolved }}</ion-label>
                </ion-chip>
              }
            }
            @if (parseResult.confidence === 'full') {
              <span class="preview-hint" aria-hidden="true">⏎ Invio</span>
            }
          </div>
        }

        @if (missingSlotHint) {
          <div class="slot-hint" aria-live="polite" role="status">
            <ion-icon name="arrow-forward-outline" color="medium" aria-hidden="true"></ion-icon>
            <span>{{ missingSlotHint }}</span>
          </div>
        }

        <div class="sr-only" aria-live="polite">{{ resultsAnnouncement }}</div>

        <ion-list id="palette-results" role="listbox" aria-label="Azioni disponibili" class="palette-list">
          @for (action of filteredActions; track action.id; let i = $index) {
            <ion-item
              [id]="'palette-item-' + i"
              button="true"
              (click)="selectAction(action)"
              [ngClass]="{ 'palette-item-active': i === activeIndex }"
              role="option"
              [attr.aria-selected]="i === activeIndex">
              <ion-icon [name]="action.icon" slot="start" aria-hidden="true"></ion-icon>
              <ion-label>{{ action.label }}</ion-label>
            </ion-item>
          }
          @if (filteredActions.length === 0) {
            <ion-item lines="none">
              <ion-label class="ion-text-center" color="medium">Nessuna azione trovata</ion-label>
            </ion-item>
          }
        </ion-list>
      </div>
    }

    @case ('select-child') {
      <div class="palette-select-child">
        <ion-toolbar color="primary">
          <ion-buttons slot="start">
            <ion-button (click)="goBackToSearch()" aria-label="Torna alla ricerca">
              <ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon>
            </ion-button>
          </ion-buttons>
          <ion-title class="fs-pt-16">Per quale studente?</ion-title>
        </ion-toolbar>

        <div class="child-chips-container">
          @for (studente of studenti; track studente.id) {
            <ion-chip
              (click)="selectChild(studente)"
              [attr.aria-label]="studente.nome + ' ' + studente.cognome">
              <div class="chip-content">
                <span class="chip-label">{{ studente.nome }}</span>
                <span class="chip-sublabel">{{ studente.cognome }}</span>
              </div>
            </ion-chip>
          }
        </div>
      </div>
    }

    @case ('action-form') {
      @if (selectedAction && selectedStudente) {
        <app-calendar-action-form
          [action]="selectedAction"
          [studente]="selectedStudente"
          [prefilledDateInizio]="prefilledDateInizio"
          [prefilledDateFine]="prefilledDateFine"
          (saved)="onFormSaved()"
          (back)="onFormBack()">
        </app-calendar-action-form>
      }
    }

    @case ('amount-form') {
      <div class="palette-amount-form">
        <ion-toolbar color="primary">
          <ion-buttons slot="start">
            <ion-button (click)="goBackToSearch()" aria-label="Torna alla ricerca">
              <ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon>
            </ion-button>
          </ion-buttons>
          <ion-title class="fs-pt-16">GENERA PAGAMENTO</ion-title>
        </ion-toolbar>

        <div class="amount-form-content">
          <p class="amount-form-label">
            Inserisci l'importo per {{ selectedStudente?.nome }}
          </p>

          @if (residuoHint !== null) {
            <div class="amount-hint" role="note">
              <ion-icon name="information-circle-outline" color="primary" aria-hidden="true"></ion-icon>
              <span>Importo suggerito: {{ residuoHint | currencyEuro }}</span>
            </div>
          }

          <ion-item lines="none" class="amount-input-item">
            <ion-icon name="card-outline" slot="start" aria-hidden="true"></ion-icon>
            <ion-input
              type="number"
              inputmode="decimal"
              placeholder="0,00"
              [value]="amountInput"
              (ionInput)="onAmountChange($any($event).detail.value ?? '')"
              aria-label="Importo in euro"
              min="0.01"
              step="0.01">
            </ion-input>
            <span slot="end" class="amount-currency">€</span>
          </ion-item>

          <div class="ion-padding">
            <ion-button
              expand="block"
              color="primary"
              [disabled]="!amountInput || amountInput <= 0"
              (click)="confirmAmount()"
              class="ion-text-uppercase">
              Conferma Importo
            </ion-button>
          </div>
        </div>
      </div>
    }

    @case ('remove-form') {
      <div class="palette-remove-form">
        <ion-toolbar color="primary">
          <ion-buttons slot="start">
            <ion-button (click)="goBackToSearch()" aria-label="Torna alla ricerca">
              <ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon>
            </ion-button>
          </ion-buttons>
          <ion-title class="ion-text-uppercase fs-pt-16">{{ selectedAction?.label }}</ion-title>
        </ion-toolbar>

        <div class="remove-form-content">
          <p class="remove-form-label">{{ removeFormQuestion }}</p>

          @if (loadingRemoveEvents) {
            <div class="chips-loader" role="status" aria-label="Caricamento eventi">
              <ion-spinner name="crescent" color="primary"></ion-spinner>
              <span>Caricamento eventi…</span>
            </div>
          }

          @if (!loadingRemoveEvents && removeChips.length > 0) {
            <div class="remove-chips-grid">
              @for (chip of removeChips; track chip.evento.id) {
                <ion-chip
                  [ngClass]="{ 'chip-selected': chip === selectedRemoveChip }"
                  (click)="selectRemoveChip(chip)"
                  [attr.aria-label]="'Rimuovi evento del ' + chip.shortDate"
                  [attr.aria-pressed]="chip === selectedRemoveChip">
                  <div class="chip-content">
                    <span class="chip-label">{{ chip.label }}</span>
                    <span class="chip-date">{{ chip.shortDate }}</span>
                  </div>
                </ion-chip>
              }
            </div>

            <div class="ion-padding">
              <ion-button
                expand="block"
                color="danger"
                [disabled]="!selectedRemoveChip"
                (click)="confirmRemoveFromForm()"
                class="ion-text-uppercase">
                {{ removeButtonLabel }}
              </ion-button>
            </div>
          }
        </div>
      </div>
    }

    @case ('confirm') {
      <div class="palette-confirm" role="region" aria-label="Riepilogo azione">
        <ion-toolbar color="primary">
          <ion-buttons slot="start">
            <ion-button (click)="goBackToSearch()" aria-label="Torna alla ricerca">
              <ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon>
            </ion-button>
          </ion-buttons>
          <ion-title class="fs-pt-16">{{ isRemoveConfirm ? 'CONFERMA RIMOZIONE' : isPaymentConfirm ? 'CONFERMA PAGAMENTO' : 'CONFERMA AZIONE' }}</ion-title>
        </ion-toolbar>

        <div class="confirm-content">
          <div class="confirm-row">
            <ion-icon [name]="selectedAction?.icon || 'flash-outline'" color="primary" aria-hidden="true"></ion-icon>
            <div class="confirm-detail">
              <span class="confirm-label">Azione</span>
              <span class="confirm-value">{{ confirmActionLabel }}</span>
            </div>
          </div>

          <div class="confirm-row">
            <ion-icon name="person-outline" color="primary" aria-hidden="true"></ion-icon>
            <div class="confirm-detail">
              <span class="confirm-label">Studente</span>
              <span class="confirm-value">{{ confirmStudenteName }}</span>
              @if (confirmFuzzyHint) {
                <span class="confirm-fuzzy-hint" role="note">
                  (hai scritto «{{ confirmFuzzyHint }}»)
                </span>
              }
            </div>
          </div>

          @if (isPaymentConfirm) {
            <div class="confirm-row">
              <ion-icon name="card-outline" color="primary" aria-hidden="true"></ion-icon>
              <div class="confirm-detail">
                <span class="confirm-label">Importo</span>
                <span class="confirm-value">{{ confirmAmountLabel }}</span>
              </div>
            </div>
          } @else {
            <div class="confirm-row">
              <ion-icon name="calendar-outline" color="primary" aria-hidden="true"></ion-icon>
              <div class="confirm-detail">
                <span class="confirm-label">Data</span>
                <span class="confirm-value">{{ confirmDateLabel }}</span>
              </div>
            </div>
          }

          <!-- Validation spinner -->
          @if (loadingValidation) {
            <div class="confirm-loading" role="status" aria-label="Verifica disponibilità">
              <ion-spinner name="crescent" color="primary"></ion-spinner>
              <span>Verifica disponibilità…</span>
            </div>
          }

          <!-- Validation warnings -->
          @if (confirmWarnings.length > 0) {
            <div class="confirm-warnings" role="alert">
              @for (warning of confirmWarnings; track warning) {
                <div class="confirm-warning-item">
                  <ion-icon name="warning-outline" color="danger" aria-hidden="true"></ion-icon>
                  <span>{{ warning }}</span>
                </div>
              }
            </div>
          }

          @if (!loadingValidation) {
            <div class="confirm-buttons">
              @if (isRemoveConfirm) {
                <ion-button
                  expand="block"
                  color="danger"
                  (click)="confirmRemove()"
                  [disabled]="!canConfirm || confirmSaving"
                  class="ion-text-uppercase"
                  aria-label="Conferma rimozione">
                  @if (confirmSaving) {
                    <ion-spinner name="crescent" slot="start"></ion-spinner>
                  }
                  Conferma Rimozione
                </ion-button>
              } @else if (isPaymentConfirm) {
                <ion-button
                  expand="block"
                  color="primary"
                  (click)="confirmSavePayment()"
                  [disabled]="!canConfirm || confirmSaving"
                  class="ion-text-uppercase"
                  aria-label="Conferma pagamento">
                  @if (confirmSaving) {
                    <ion-spinner name="crescent" slot="start"></ion-spinner>
                  }
                  Genera Pagamento
                </ion-button>
              } @else {
                <ion-button
                  expand="block"
                  color="primary"
                  (click)="confirmSave()"
                  [disabled]="!canConfirm || confirmSaving"
                  class="ion-text-uppercase"
                  aria-label="Conferma e salva">
                  @if (confirmSaving) {
                    <ion-spinner name="crescent" slot="start"></ion-spinner>
                  }
                  Conferma Azione
                </ion-button>
              }
              <ion-button
                expand="block"
                fill="outline"
                color="primary"
                (click)="confirmModify()"
                [disabled]="confirmSaving"
                class="ion-text-uppercase"
                aria-label="Modifica i dettagli">
                Modifica
              </ion-button>
            </div>
          }
        </div>
      </div>
    }

  }

</div>
